// @flow
import { LayoutType } from "./actions";
import {
	CHANGE_LAYOUT,
	CHANGE_LAYOUT_WIDTH,
	CHANGE_SIDEBAR_THEME,
	CHANGE_SIDEBAR_TYPE,
	CHANGE_TOPBAR_THEME,
	TOGGLE_RIGHT_SIDEBAR,
	SHOW_RIGHT_SIDEBAR,
	CHANGE_PRELOADER,
	HIDE_RIGHT_SIDEBAR,
	SEARCH_SELECTION,
	SET_LOGO
} from "./actionTypes";

export interface ILayout {
	layoutType: LayoutType,
	layoutWidth: string,
	leftSideBarTheme: string,
	leftSideBarType: string,
	topbarTheme: string,
	isPreloader: boolean,
	showRightSidebar: boolean,
	isMobile: boolean,
	searchSelection: string,
	customTerm: string,
	logo: string
};

const INIT_STATE: ILayout = {
	layoutType: "vertical",
	layoutWidth: "fluid",
	leftSideBarTheme: "light",
	leftSideBarType: "compact",
	topbarTheme: "dark",
	isPreloader: false,
	showRightSidebar: false,
	isMobile: false,
	searchSelection: "",
	customTerm: "",
	logo: ""
};
//type Action = hideRightSidebar|changeLayout|changeSidebarTheme|changeSidebarType|changeLayoutWidth|changeTopbarTheme|changePreloader;
const Layout = (state = INIT_STATE, action: any) => {
	switch (action.type) {
		case CHANGE_LAYOUT:
			return {
				...state,
				layoutType: action.payload
			};
		case CHANGE_PRELOADER:
			return {
				...state,
				isPreloader: action.payload
			};

		case CHANGE_LAYOUT_WIDTH:
			return {
				...state,
				layoutWidth: action.payload.width
			};
		case CHANGE_SIDEBAR_THEME:
			return {
				...state,
				leftSideBarTheme: action.payload.theme
			};
		case CHANGE_SIDEBAR_TYPE:
			return {
				...state,
				leftSideBarType: action.payload.sidebarType
			};
		case CHANGE_TOPBAR_THEME:
			return {
				...state,
				topbarTheme: action.payload
			};
		case TOGGLE_RIGHT_SIDEBAR:
			return {
				...state,
				showRightSidebar: !state.showRightSidebar
			};
		case SHOW_RIGHT_SIDEBAR:
			return {
				...state,
				showRightSidebar: true
			};
		case HIDE_RIGHT_SIDEBAR:
			return {
				...state,
				showRightSidebar: false
			};
		case SEARCH_SELECTION:
			return {
				...state,
				isPreloader: action.payload,
				searchSelection: action.searchSelection,
				customTerm: action.term
			};
		case SET_LOGO:
			return{
				...state,
				logo: action.payload
			};
		default:
			return state;
	}
};

export default Layout;
